const getData = i18n => i18n.p$data.value().resource.data;

export const mergeI18n = (target, parentI18n) => {
  // catch error in mock i18n
  try {
    Object.assign(getData(target), getData(parentI18n));
  } catch (error) {
    console.warn(error);
  }
};
